import { LoggerFactory } from '@elderbyte/ts-logger'

export class StoragePath {
  /***************************************************************************
   *                                                                         *
   * Static fields                                                           *
   *                                                                         *
   **************************************************************************/

  private static readonly log = LoggerFactory.getLogger('StoragePath')

  public static readonly DELIMITER = '/'

  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly _elements: string[]

  /***************************************************************************
   *                                                                         *
   * Static methods                                                          *
   *                                                                         *
   **************************************************************************/

  public static of(elements: string[]): StoragePath {
    return new StoragePath(elements)
  }

  public static parse(pathStr: string): StoragePath {
    if (pathStr == null) {
      throw Error('path was null!')
    }

    let path: StoragePath

    if (!pathStr) {
      path = new StoragePath([])
    } else {
      path = new StoragePath(pathStr.split(this.DELIMITER))
    }
    this.log.trace('Parsed StoragePath:', path)
    return path
  }

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor(elements: string[]) {
    this._elements = elements
  }

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  public get elements(): string[] {
    return this._elements
  }

  public get facilityId(): string {
    return !this.isEmpty ? this.elements[0].toLowerCase() : null
  }

  public get isValidStorageNodePath(): boolean {
    // first level is only facility
    return this.level > 1
  }

  public get isEmpty(): boolean {
    return !this.elements || this.elements.length === 0
  }

  public get level(): number {
    return !this.isEmpty ? this.elements.length : 0
  }

  public get parentPath(): StoragePath {
    if (this.elements?.length > 0) {
      const parentPathElements = this.elements.slice(0, -1)
      return StoragePath.of(parentPathElements)
    } else {
      StoragePath.of([])
      return undefined // TODO: probably not intended
    }
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public isSubPathOfPath(path: StoragePath): boolean {
    return this.isSubPathOfPathString(path.serialize())
  }

  public isSubPathOfPathString(path: string): boolean {
    return this.serialize().startsWith(path)
  }

  public serialize(): string {
    if (!this.isEmpty) {
      return this.elements.join(StoragePath.DELIMITER).toUpperCase()
    } else {
      return ''
    }
  }
}
